<template>
  <div id="v2-course-product-main">
    <BottomBar />
    <Empty
      v-if="!course"
      :loading="course === undefined"
      :icon="true"
      title="找不到课程"
      subtitle="课程不存在，或已下架"
      link="/courses"
      link-text="查看更多课程"
    />
    <div v-else id="v2-course-product-content" :style="getPadding(extraPadding)" class="noscroll">
      <ViewOne v-if="course.banner" :data="course" @isShowPay="isShowPay = true" />
      <ViewTwo v-else :data="course" @isShowPay="isShowPay = true" />
      <div v-if="course.content || course.plan || course.objectives" class="content">
        <Block v-if="course.content" title="课程简介" :content="course.content" />
        <Block v-if="course.plan" title="环节安排" :content="course.plan" />
        <Block v-if="course.objectives" title="学习目标" :content="course.objectives" />
      </div>
      <Articles v-if="course.articles.length" :articles="course.articles" />
      <Videos v-if="course.videos.length" :videos="course.videos" />
      <Comments v-if="course.comments.length" :images="course.comments" />
      <Share v-if="$store.state.login !== undefined && course" :course="course" :color="color" />
      <Features v-if="course" :is-component="true" :course-type="course.type_id" :color="color" />
      <Cashier
        v-if="course"
        :title="course.title"
        :color="color"
        :custom-style="cashierStyles[cashierStyle]"
        :subtitle="
          course.events.length > 1 ? course.events.length + ' 个场次 / 价格可选' : course.subtitle
        "
        :price="priceStr"
        :is_promo="course.is_promo"
        :label="priceLabel"
        :comments="Boolean(course.comments.length)"
        :videos="Boolean(course.videos.length)"
        :articles="Boolean(course.articles.length)"
        @status="showEvent"
      />
    </div>
    <Events
      v-if="course && isShowEvent && user && user.mobile && !components.login"
      :events="course.events"
      :title="course.title"
      :subtitle="course.subtitle"
      :type="course.type_name"
      :img="course.img"
      :color="color"
      @pay="showPay($event)"
      @status="status += $event"
      @close="isShowEvent = false"
    />
    <Pay
      v-if="isShowPay"
      :is_livecode="course.is_livecode"
      :title="course.title"
      :course-type="course.type_id"
      :subtitle="
        payload.event.event_title || $moment(payload.event.start_time).format('M月D日') + '场'
      "
      :data="payload"
      @success="getData()"
      @close="isShowPay = false"
    />
    <Login v-if="components.login" v-on:dismiss="components.login = false" />
  </div>
</template>
<script>
import ViewOne from "./ViewOne"
import ViewTwo from "./ViewTwo"
import BottomBar from "@/components/public/footer"
import Features from "@/components/home/Features"
import Cashier from "./Cashier"
import Events from "../events/Main"
import Block from "./Block"
import Share from "./Share"
import Pay from "../pay/Main"
import Login from "@/components/popup/Login"
import Comments from "./Comments"
import Articles from "./Articles"
import Videos from "@/components/v2/course/product/Videos"

export default {
  name: "V2CourseProductMain",
  components: {
    Block,
    Share,
    ViewOne,
    ViewTwo,
    BottomBar,
    Cashier,
    Features,
    Events,
    Pay,
    Login,
    Comments,
    Articles,
    Videos,
  },
  data() {
    return {
      status: 0,
      course: undefined,
      extraPadding: 0,
      isShowEvent: false,
      isShowPay: false,
      priceText: "",
      priceLabel: "",
      cashierStyle: 1,
      cashierStyles: { 0: "static", 1: "fixed", 2: "bottom" },
      payload: null,
      poster: null,
      components: {
        login: false,
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    color() {
      return this.course && this.course.color ? `rgb(${this.course.color})` : "#ed254e"
    }
  },
  watch: {
    "$route": {
      immediate: true,
      handler(val) {
        const { query } = val
        if (query.pay) {
          this.showEvent()
        }
      }
    },
    user: {
      immediate: true,
      handler(val) {
        if (val.user_id && !val.mobile && this.isShowEvent) {
          this.components.login = true
        }
        if (val.mobile && this.isShowEvent) {
          this.components.login = false
        }
        if (val && this.course) {
          this.wechatInit()
        }
      }
    },
    course: function (val) {
      if (!val) return
      window.document.title = val.title
      const minPrice = val.events.reduce((accumulator, value) => {
        if (value.price < accumulator && value.is_demo == 0) {
          accumulator = value.price
        }
        return accumulator
      }, val.events[0].price)
      const maxPrice = val.events.reduce((accumulator, value) => {
        if (value.price > accumulator) {
          accumulator = value.price
        }
        return accumulator
      }, val.events[0].price)

      if (maxPrice === minPrice && maxPrice !== 0) {
        this.priceStr = `¥${minPrice}`
      } else if (maxPrice !== minPrice && maxPrice !== 0) {
        this.priceStr = `¥${minPrice} 起`
      } else {
        this.priceStr = "免费"
      }

      this.$nextTick(() => {
        this.bindScroll()
      })
    },
  },
  async created() {
    const redirectUrl = `${window.homePageUrl}${this.$route.fullPath}`
    if (location.href != redirectUrl) {
      window.location.replace(redirectUrl)
    }
    const { query } = this.$route
    if (query.refresh) {
      let url = `${homePageUrl}${this.$route.path}`
      if (query.showEvent) {
        url += "?showEvent=1"
      }
      return window.location.replace(url)
    }
    // if (query.pay && query.cd_id && query.method) {
    //   this.$toastLoading("正在恢复订单信息")
    // }
    this.getData()
    this.$wxConfig(true)
  },
  beforeDestroy() {
    document.onscroll = null
  },
  mounted() {
    if (this.$route.query.showEvent) {
      this.isShowEvent = true
    }
  },
  destroyed() {
    this.$enableScroll()
  },
  deactivated() {
    this.$enableScroll()
  },
  methods: {
    showEvent() {
      this.isShowEvent = true
      if (!this.user.mobile) {
        this.components.login = true
      }
    },
    showPay(event) {
      this.payload = event
      if (this.user.mobile) {
        this.isShowPay = true
      } else {
        this.components.login = true
      }
    },
    async getData() {
      try {
        const config = {
          url: v2Url + "/course/specialCourseDetails",
          method: "POST",
          data: { id: this.$route.params.id, over_time: 0 },
        }
        const { data } = await this.$axios(config)
        const { code, msg } = data
        if (code == 1000) {
          msg.events.sort((a, b) => b.sort - a.sort)
          msg.events.forEach(i => {
            i.price = parseFloat(i.price)
          })
          this.course = msg
          this.wechatInit()
        } else {
          this.course = null
        }
      } catch (err) {
        throw new Error(err)
      }
    },
    getPadding(height) {
      return `padding-bottom: ${height}px`
    },
    bindScroll() {
      this.extraPadding = 40
      document.onscroll = () => {
        const height =
          window.document.documentElement.scrollTop + window.document.documentElement.clientHeight
        let isScrollBottom = height > window.document.documentElement.scrollHeight - 20
        this.cashierStyle = isScrollBottom ? 2 : 1
      }
    },
    wechatInit() {
      let title, desc, link, imgUrl
      link = window.homePageUrl + this.$route.path
      imgUrl = this.course.img
      if (this.user && this.user.user_id) {
        title = `${this.user.name}邀请你看看「${this.course.title}」`
        desc = `${this.course.subtitle}`
        link = link + "?friend=" + this.user.user_id
      } else {
        title = this.course.title
        desc = this.course.subtitle
      }

      this.$wxShare({ title, link, desc, imgUrl })
    },
  },
}
</script>
<style scoped lang="scss">
@import "../style.scss";

#v2-course-product-main {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  position: relative;
  width: 100%;
  height: 100%;
  margin-bottom: 15px;

  .content {
    padding: 0 5% 20px 5%;
  }
  .empty {
    height: 80vh;
  }
}
</style>
